// import store from '@/store/index.js'
// let dic = store.state.dic;

export default function Configs(that) {

    const searchItems = [
        {
            label: "身份证号",
            span: 8,
            placeholder: '请输入身份证号',
            model: "idCard",
        },
        
    ]
    const tableColumns = [
        {
            label: "班级",
            prop: "88",
            align: "center",
            show: true
        },
        {
            label: "身份证号",
            prop: "11",
            align: "center",
            show: true
        },
        {
            label: "姓名",
            prop: "22",
            align: "center",
            show:true
        },
        {
            label: "亲属人数",
            prop: "33",
            align: "center",
            show:true
        },
        {
            label: "称谓",
            prop: "44",
            align: "center",
            show:true
        },
        {
            label: "亲友姓名",
            prop: "55",
            align: "center",
            show:true
        },
        {
            label: "身份证号",
            prop: "66",
            align: "center",
            show:true
        },
        {
            label: "联系方式",
            prop: "77",
            align: "center",
            show: true
        },
        {
            label: "工作单位",
            prop: "88",
            align: "center",
            show: true
        },
        {
            label: "职务",
            prop: "99",
            align: "center",
            // width:'150px',
            show:true
        },
    ]

    return {
        searchItems,
        tableColumns
    }
}
